export const DEFAULT_EQUALS = (a, b) => a === b;
export const FALSE_EQUALS = () => false;
export const equalsFrom = (equals) => {
    if (equals === false) {
        return FALSE_EQUALS;
    }
    return equals ?? DEFAULT_EQUALS;
};
